import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createOperatorItem,
  getAllOperatorItems,
  getDataForEdit,
  updateOperatorItem,
  deleteOperatorItem,
} from "../../store/Operator/OperatorApi";
import { getAllFactoryItems } from "../../store/AppLevelApi/AppLevelApi";
import { headTitle } from "../../utility/GetTableListName";
import { operatorSliceAction } from "../../store/Operator/OperatorSlice";

import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsOperator } from "../../ConstantData/FormOptions";
//importing inital form data to store value state
import { InitialOperatorCostFormData } from "../../ConstantData/InitialData";
//imporint form data error
import { ErrorOperatorCostFormData } from "../../ConstantData/ErrorOption";
function Operator() {
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getAllOperatorItems());
    // dispatch(getAllFactoryItems());
  }, []);
  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const operatorList = useSelector((state) => state.operator.operatorList); //store user list
  const operatorDataEdit = useSelector((state) => state.operator.dataEdit);
  let isError = useSelector((state) => state.operator.isError);
  let operatorFormError = useSelector((state) => state.operator.errorData);
  operatorFormError = { ...ErrorOperatorCostFormData, ...operatorFormError };

  const factoryList = useSelector((state) => state.applevel.factoryList);
  let newFormOptionsUser = JSON.parse(JSON.stringify(FormOptionsOperator));

  if (factoryList.length > 0) {
    //to chage factory option coming from server
    newFormOptionsUser = FormOptionsOperator.map((item) => {
      if (item?.labelName === "Factory") {
        item.options = factoryList;
      }
      return item;
    });
  }

  //function to get list heading
  const headTitleLabel = headTitle(FormOptionsOperator, [
    "Name",
    "Factory",
    "Contact Number",
    "status",
  ]); //array is filed that is included in list heading

  return (
    <MainComponent
      InitialFormData={InitialOperatorCostFormData}
      createFun={createOperatorItem} //create function coming from store
      updateFun={updateOperatorItem} //update function coming from store
      getDataForEdit={getDataForEdit} //edit function coming from store
      delteFun={deleteOperatorItem}
      FormOptions={newFormOptionsUser}
      OptionName="Create Operator"
      OptionNameList="Operator"
      generalList={operatorList}
      headTitle={headTitleLabel}
      isError={isError}
      ErrorData={operatorFormError}
      setErrorData={operatorSliceAction.setErrorData}
      EditData={operatorDataEdit}
      generalModuleList={factoryList} //list to add different module
      isNotDeleteBtn={false}
      isSuccess={isSuccess}
    />
  );
}

export default Operator;
